import { EMPTY_STRING } from '../../../../constants/common'

export function getEmailAccountSelectFieldError({ selectedValue, t }) {
  if (selectedValue && !Number.isInteger(selectedValue?.value)) {
    return t('Error.IncorrectValueKey')
  }

  return EMPTY_STRING
}
